import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const updateWeekListWaitHappy = (data) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/happyWaiting/weeks',
      'authenticated': true,
      'types': [
        ActionTypes.UPDATING_LIST_WEEK_WAIT_HAPPY,
        [
          () => ({'type': ActionTypes.UPDATED_LIST_WEEK_WAIT_HAPPY}),
          () => MessageActions.addMessageBoxInfo('Registro Actualizado'),
        ],
        [ActionTypes.UPDATED_LIST_WEEK_WAIT_HAPPY_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'contentType': 'application/json',
      'method': 'PUT',
      'data': data,
    })
  );
};


export const updateDealerWaitHappy = (data) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/happyWaiting/dates',
      'authenticated': true,
      'types': [
        ActionTypes.UPDATING_DEALER_WAIT_HAPPY,
        [
          () => ({'type': ActionTypes.UPDATED_DEALER_WAIT_HAPPY}),
          () => MessageActions.addMessageBoxInfo('Registro Actualizado'),
        ],
        [ActionTypes.UPDATED_DEALER_WAIT_HAPPY_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'contentType': 'application/json',
      'method': 'PUT',
      'data': data,
    })
  );
};
